// Public read of the admin-managed Staff Certs list from Supabase.
//
// Replaces the Apps Script `getStaffCerts` POST the kitchen Compliance hub used — same
// PUBLIC exposure (that action sits in EXEMPT_ACTIONS, ManchesterReportWriter.js:265,
// and its handler has no admin gate), just served from Supabase now. Returns the ACTIVE
// certs; archived rows are hidden by RLS (0017). Writes stay admin-only (Command Centre
// → admin-data).
//
// NO SITE FILTER AND NO KEY NORMALISATION — deliberate, don't "fix" it. StaffCerts has
// no Site column: openSheetFor_ routes it to the ONE global admin sheet and both
// handlers pass site=null. The 'mcr' -> 'kitchen' trap that bit the Tiles cutover does
// not apply here — there is no per-site cert list to lose.
import { supabase } from "./supabaseClient.js";

// Exported for the unit test (staffCerts.test.mjs), which pins the field mapping the
// Compliance hub reads. `rows` are raw table rows in; returns the old reader's shape.
export function mapCerts(rows) {
  return (rows || []).map((r) => ({
    certId: r.cert_id,
    staff: r.staff_name,
    cat: r.category,
    issued: r.issued_date || "",   // date column renders as 'YYYY-MM-DD'; null -> ''
    expires: r.expires_date || "",
    fileUrl: r.file_url || "",
    notes: r.notes || "",
    status: r.status,
  }));
}

export async function fetchStaffCerts() {
  const { data, error } = await supabase
    .from("staff_certs")
    .select("cert_id,staff_name,category,issued_date,expires_date,file_url,notes,status")
    .eq("status", "active");   // belt-and-braces; RLS already scopes this
  if (error) throw new Error(error.message || "Failed to load staff certs");

  // ── Do NOT copy tileOverrides.js's "an empty read is a FAILURE" throw. ───────
  // That guard is right for tiles and wrong here. For tiles, empty is impossible — the
  // estate always has the '*' rows — so empty means broken, and a poisoned {} gets
  // cached to localStorage and reverts every kiosk to its hardcoded defaults. None of
  // that holds for certs: EMPTY IS THE TRUE AND CURRENT STATE (the live sheet has zero
  // rows, probed 15 Jul), "No staff certs on file yet" is what the kitchen shows today,
  // and there is no cache in this path to poison. Throwing would replace a correct
  // empty state with a red error box.
  return mapCerts(data);
}
